import { Buttons } from '../../Modal'
import { TableModalButtonAttach } from '../TableModalButtonAttach'
import { TableModalButtonCancel } from '../TableModalButtonCancel'

function TableModalActions({
  ButtonAttach = TableModalButtonAttach,
  ButtonCancel = TableModalButtonCancel,
  ButtonExport,
  Component = Buttons,
  buttonAttachProps,
  buttonCancelProps,
  buttonExportProps,
  children,
  componentProps,
  isSkeleton,
}) {
  return (
    <Component {...componentProps} size='l'>
      {ButtonAttach ? (
        <ButtonAttach {...buttonAttachProps} isSkeleton={isSkeleton} />
      ) : null}
      {ButtonCancel ? (
        <ButtonCancel {...buttonCancelProps} isSkeleton={isSkeleton} />
      ) : null}
      {ButtonExport ? (
        <ButtonExport {...buttonExportProps} isSkeleton={isSkeleton} />
      ) : null}
      {children}
    </Component>
  )
}

export default TableModalActions
